import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const AppSettingsService = {
  createAppSetting: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.APPSETTINGS.CREATEAPPSETTING,
      data
    );
    return response;
  },

  updateAppSetting: async (parameter, data) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.APPSETTINGS.UPDATEAPPSETTING,
      {
        parameter,
      }
    );
    const response = await api.patch(endpoint, { value: data });
    return response;
  },

  listAppSettings: async () => {
    const response = await api.get(API_ENDPOINTS.APPSETTINGS.LISTAPPSETTINGS);
    return response;
  },
};
